import type { JSX } from 'solid-js';
import { AdminGate } from '../components/AdminGate';
import { AdminOverviewPanel } from '../components/AdminOverviewPanel';
import { SESSION_TOKEN } from '../lib/session';

// Platform radar route (admin.developerz.ai). Thin: the closed-beta <AdminGate/>
// wraps the panel so its `/v1/admin/*` reads only fire for `developerz-ai` staff
// (the gated panel never mounts for an outsider → no fetch). `token` is
// injectable for tests; the router mounts this with no props → dev/prod session.

export function AdminOverview(props: { token?: string | null } = {}): JSX.Element {
  const token = props.token ?? SESSION_TOKEN;
  return (
    <AdminGate token={token}>
      <AdminOverviewPanel token={token} />
    </AdminGate>
  );
}
